<div class="lendio-density-1">
    <mat-form-field
        class="w-full"
        shouldLabelFloat="true"
        [floatLabel]="'always'"
        appearance="outline">
        <mat-label>Assigned To:</mat-label>
        <mat-select
            placeholder="Unassigned"
            [multiple]="true"
            [value]="selection.selected"
            (selectionChange)="selectionChanged($event)"
        >
            <mat-option
                *ngFor="let user of portalUsers"
                [value]="user.id">{{user.fullName}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
